import { Component, computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { NavigationRailComponent } from './components/navigation-rail/navigation-rail.component';
import { PocketbaseService } from './services/pocketbase.service';
import { map } from 'rxjs/internal/operators/map';
import { filter } from 'rxjs/internal/operators/filter';
@Component({
    selector: 'app-root',
    imports: [RouterOutlet, FooterComponent, NavigationRailComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  public readonly isLoggedIn: Signal<boolean>;

  constructor(private readonly pocketbaseService: PocketbaseService) {
    this.isLoggedIn = this.pocketbaseService.loggedIn;
  }

  //für den Beta-Test hinzugefügt:

  // Router wird so injiziert, um sowohl auf Navigationsevents zu hören als auch später programmatisch navigieren zu können (Zurück-Button)
  public readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  // Liest bei jeder abgeschlossenen Navigation das tiefste aktive Route-Segment aus und prüft dessen `data.hideShell` Flag
  public readonly hideShell = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        // Bis zur tiefsten aktiven Kind-Route durchhangeln,
        // da data auf der jeweiligen Route-Config sitzt
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data['hideShell'] === true;
      })
    ),
    { initialValue: false }
  );

  // Sidebar/Footer nur zeigen, wenn eingeloggt UND nicht explizit versteckt
  protected readonly showShell = computed(
    () => this.isLoggedIn() && !this.hideShell()
  );

  protected goBack(): void {
    this.router.navigate(['/']);
  }

}
